module.exports = __webpack_public_path__ + "static/wow-a4be273da780a3646f869c5eaf99a33b.png";